import SettingTypes from '@/utils/setting-types'

export default {
  name: 'goods-and-image',
  label: {
    title: '商品和图片',
    icon: require('@/assets/icon-component-label_GoodsAndImage.svg'),
    limit: -1
  },
  sort: 3,
  data: {
    title: '展区标题',
    goodsList: [],
    picture: {}
  },
  settings: {
    title: {
      type: SettingTypes.input,
      label: '展区标题',
      props: {
        placeholder: '请填写展区标题！',
        maxlength: 20
      },
      space_line: true
    },
    goodsList: {
      type: SettingTypes.goods_selector,
      label: '选择商品',
      limit: 4,
      space_line: true
    },
    picture: {
      type: SettingTypes.custom,
      component_name: 'GoodsAndImagePictureSelector'
    }
  }
}
